module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c3ed388cfda5c066758f95c14b8e3afa.png";